import Feed from './Feed.container';

export default Feed;
